export enum BlockTypeEnum {
  APPROVAL = 'APPROVAL',
  BUDGET_APPROVAL = 'BUDGET_APPROVAL',
  CHILD_REQUEST_START = 'CHILD_REQUEST_START',
  SUB_WORKFLOW_START = 'SUB_WORKFLOW_START',
  ENGAGEMENT = 'ENGAGEMENT',
  HTTP = 'HTTP',
  INTAKE = 'INTAKE',
  MILESTONE = 'MILESTONE',
  NOTIFICATION = 'NOTIFICATION',
  RENEWAL_ASSESSMENT = 'RENEWAL_ASSESSMENT',
  SUPPLIER_ONBOARDING = 'SUPPLIER_ONBOARDING',
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  EXTERNAL_PROCEDURE = 'EXTERNAL_PROCEDURE',
  CREATE_RENEWAL = 'CREATE_RENEWAL',
  COMMIT_SUPPLIER_DATA = 'COMMIT_SUPPLIER_DATA',
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  CANCEL_AGREEMENT = 'CANCEL_AGREEMENT',
  CANCEL_ASSESSMENTS = 'CANCEL_ASSESSMENTS',
  CREATE_PO = 'CREATE_PO',
  RFX = 'RFX',
  AUCTION = 'AUCTION',
  CREATE_ASSESSMENT = 'CREATE_ASSESSMENT',
  PRICE_BENCHMARK = 'PRICE_BENCHMARK',
  DATA_TRANSFORMATION = 'DATA_TRANSFORMATION',
  WAITING = 'WAITING',
  SUPPLIER_ONLINE_RESOURCES = 'SUPPLIER_ONLINE_RESOURCES',
  INHERENT_RISK_ASSESSMENT = 'INHERENT_RISK_ASSESSMENT',
  RISK_CONTROLS_AGENT = 'RISK_CONTROLS_AGENT',
  NOTIFY_SLACK = 'NOTIFY_SLACK',
  REJECT_REQUEST = 'REJECT_REQUEST',
  NOTIFY_TEAMS = 'NOTIFY_TEAMS',
}

// Blocks whose steps run the Approval stage, so a check tied to that stage's behaviour applies to all of them.
export const APPROVAL_STAGE_BLOCK_TYPES = [
  BlockTypeEnum.APPROVAL,
  BlockTypeEnum.INHERENT_RISK_ASSESSMENT,
  BlockTypeEnum.RISK_CONTROLS_AGENT,
] as const

export const isBlockType = (value: string): value is BlockTypeEnum => Object.values<string>(BlockTypeEnum).includes(value)

export type ApprovalStageBlockType = (typeof APPROVAL_STAGE_BLOCK_TYPES)[number]

export const isApprovalStageBlockType = (type: BlockTypeEnum): type is ApprovalStageBlockType =>
  (APPROVAL_STAGE_BLOCK_TYPES as readonly BlockTypeEnum[]).includes(type)

export const isBlockTypeWithApprover = (type?: BlockTypeEnum): boolean =>
  type !== undefined && (isApprovalStageBlockType(type) || type === BlockTypeEnum.BUDGET_APPROVAL)
